var React = require('react');

function GettingStarted (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"none","d":"M5.23,9.59v17.62h44.22l8.75-8.81l-8.75-8.81H5.23z M31.74,29.99h-1.74v31.22h1.74V29.99z M27.24,6.8\n\tV1.39c0-0.77,0.62-1.39,1.38-1.39h4.5c0.76,0,1.38,0.62,1.38,1.39V6.8h15.51c0.37,0,0.72,0.15,0.98,0.41l10.14,10.2\n\tc0.54,0.54,0.54,1.43,0,1.97L51,29.58c-0.26,0.26-0.61,0.41-0.98,0.41H34.51v32.62c0,0.77-0.62,1.39-1.38,1.39h-4.5\n\tc-0.76,0-1.38-0.62-1.38-1.39V29.99H3.85c-0.76,0-1.38-0.62-1.38-1.39V8.19c0-0.77,0.62-1.39,1.38-1.39H27.24z M30.01,6.8h1.74V2.79\n\th-1.74V6.8z"}));
}

GettingStarted.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 64 64","style":{"enableBackground":"new 0 0 64 64"},"xmlSpace":"preserve"};

module.exports = GettingStarted;

GettingStarted.default = GettingStarted;
